import Vue from 'vue';
import EventBus from '@/utils/eventBus';
import { encodePathSegment } from '@/utils/url';

export default (id, filter, cb) => {
  EventBus.$emit('show-loading', true);
  Vue.$http
    .get(`Customers/${encodePathSegment(id)}/`, {
      params: filter,
    })
    .then((response) => {
      EventBus.$emit('show-loading', false);
      cb(null, response);
    })
    .catch((error) => {
      EventBus.$emit('show-loading', false);
      cb(error);
    });
};



// WEBPACK FOOTER //
// ./src/services/customer/getOne.js